import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type EmptyKind = 'empty' | 'loading' | 'error';

@Component({
  selector: 'app-empty-state',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="empty" [attr.data-kind]="kind" role="status">
      <div class="empty__icon" aria-hidden="true">
        <ng-container [ngSwitch]="kind">
          <span *ngSwitchCase="'loading'" class="material-icons empty__spin">progress_activity</span>
          <span *ngSwitchCase="'error'" class="material-icons">error_outline</span>
          <span *ngSwitchDefault class="material-icons">inbox</span>
        </ng-container>
      </div>
      <p class="empty__msg">{{ message || defaultMessage() }}</p>
    </div>
  `,
  styles: [`
    .empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: var(--space-3);
      padding: var(--space-7) var(--space-4);
      text-align: center;
      color: var(--color-text-secondary);
      background: var(--color-surface);
      border: 1px dashed var(--color-border);
      border-radius: var(--radius-lg);
    }
    .empty[data-kind="error"] { color: var(--color-danger); border-color: var(--color-danger); }
    .empty__icon .material-icons { font-size: 40px; opacity: 0.85; }
    .empty__spin { animation: spin 1s linear infinite; }
    .empty__msg { font-size: var(--fs-sm); line-height: var(--lh-sm); }
    @keyframes spin { to { transform: rotate(360deg); } }
  `]
})
export class EmptyStateComponent {
  @Input() kind: EmptyKind = 'empty';
  @Input() message?: string;

  defaultMessage(): string {
    switch (this.kind) {
      case 'loading': return 'Loading…';
      case 'error':   return 'Something went wrong.';
      default:        return 'No posts in this topic yet.';
    }
  }
}
